import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Select, Space, Typography } from "antd";
import _ from "lodash";
import moment from "moment";
import useAuth from "../../../../lib/hooks/useAuth";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../routes";
import { SearchReportContext } from "../searchContext";
import {
  getListDepartments,
  getListDivisions,
} from "../../../../services/progressPerformance";
import { SUCCESS_CODE } from "../../../../lib/const";

const { Title } = Typography;
const { Option } = Select;

const Search = ({ roleUser }) => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const [searchForm] = Form.useForm();
  const [dropDownDepartment, setDropDownDepartment] = useState([]);
  const [listDivisions, setListDivisions] = useState([]);
  const [departmentId, setDepartmentId] = useState();

  const { setPageValues, setSearch, setSearchValues } =
    useContext(SearchReportContext);

  const createPermission =
    auth?.user?.permissions &&
    _.get(
      auth?.user?.permissions.find(
        (item) => item.permissionName === "Application field"
      ),
      "permissionList",
      []
    ).find(
      (item) =>
        item.pageName === "รายงานผลการดำเนินงานตามแผนปฏิบัติการ" &&
        _.get(item, "customPermission['Create/Update']", false) === true
    );

  const options = [];
  for (let i = 10; i < 15; i++) {
    options.push({
      value: i.toString(15) + i,
      label: i.toString(15) + i,
    });
  }

  const fetchListDepartments = useCallback(async () => {
    try {
      const res = await getListDepartments();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDepartment(result_data);
      }
    } catch (error) {}
  }, [dropDownDepartment]);

  useEffect(() => {
    fetchListDepartments();
  }, []);

  const fetchListDivisions = useCallback(async () => {
    try {
      const res = await getListDivisions(departmentId);

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setListDivisions(result_data);
      }
    } catch (error) {}
  }, [listDivisions, departmentId]);

  useEffect(() => {
    if (departmentId) {
      fetchListDivisions();
    }
  }, [departmentId]);

  const handleChangeDepartment = (value) => {
    setDepartmentId(value);
  };

  const handleChangeDivision = (value) => {
    setDepartmentId(value);
  };

  // const onChangeMonthPicker = (value) => {
  //   setMonthYear(value);
  // };

  const onSearch = (values) => {
    const year = Number(values.yearOfBudget) + 543;

    setSearchValues({
      projectName: values?.projectName,
      departmentId: values?.departmentId,
      divisionId: values?.divisionId,
      monthOfBudget: values?.monthOfBudget,
      yearOfBudget: year,
    });
    setSearch(true);
  };

  const handleClearSearchForm = () => {
    setSearch(true);
    searchForm.resetFields();

    setListDivisions([]);
    setSearchValues({
      projectName: "",
      departmentId: "",
      divisionId: "",
      monthOfBudget: "",
      yearOfBudget: "",
    });
    setPageValues({
      page: 0,
      pageSize: 10,
    });
  };
  const [year, setYear] = useState(null);
  const years = moment().add(1, "years").format("YYYY");
  const yearArray = [
    parseInt(years),
    parseInt(years - 1),
    parseInt(years - 2),
    parseInt(years - 3),
    parseInt(years - 4),
  ];

  const months = [
    {
      value: "10",
      name: "ตุลาคม",
    },
    {
      value: "11",
      name: "พฤศจิกายน",
    },
    {
      value: "12",
      name: "ธันวาคม",
    },
    {
      value: "1",
      name: "มกราคม",
    },
    {
      value: "2",
      name: "กุมภาพันธ์",
    },
    {
      value: "3",
      name: "มีนาคม",
    },
    {
      value: "4",
      name: "เมษายน",
    },
    {
      value: "5",
      name: "พฤษภาคม",
    },
    {
      value: "6",
      name: "มิถุนายน",
    },
    {
      value: "7",
      name: "กรกฎาคม",
    },
    {
      value: "8",
      name: "สิงหาคม",
    },
    {
      value: "9",
      name: "กันยายน",
    },
  ];

  return (
    <Content>
      <Form style={{ marginBottom: 20 }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <div className="flex justify-between items-center">
              <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                รายงานผลการดำเนินงานตามแผนปฏิบัติการ
              </Title>
              <div>
                <Space>
                  <Button
                    type="primary"
                    disabled={!createPermission}
                    onClick={() => navigate(routes.add_report)}
                  >
                    <PlusOutlined /> เพิ่มรายงานผลการดำเนินงาน
                  </Button>
                </Space>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      <Form
        layout={"vertical"}
        form={searchForm}
        style={{
          padding: 20,
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #F2F2F2",
          boxShadow: `0px 1px 10px 0px rgba(226, 216, 246, 0.40)`,
        }}
        onFinish={onSearch}
      >
        <Row gutter={[24, 16]}>
          <Col className="gutter-row" span={8}>
            <Form.Item label="" name="departmentId">
              <Select
                allowClear
                placeholder="ฝ่าย"
                style={{
                  width: "100%",
                }}
                maxTagCount={"responsive"}
                onChange={handleChangeDepartment}
              >
                {dropDownDepartment.map((option, i) => (
                  <Option key={i} value={option.departmentId}>
                    {option.departmentNameTh}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={8}>
            <Form.Item name={"divisionId"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="กอง"
                onChange={handleChangeDivision}
              >
                {listDivisions.map((item) => (
                  <Option value={item.divisionId}>{item.divisionNameTh}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name={"yearOfBudget"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="ปีงบประมาณ"
                maxTagCount={"responsive"}
                onChange={() => {
                  let arr = searchForm.getFieldValue().yearOfBudget;
                  setYear(arr);
                }}
                value={year}
              >
                {yearArray.map((item) => (
                  <Option value={parseInt(item)}>{parseInt(item) + 543}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name={"monthOfBudget"}>
              <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="เดือนงบประมาณ"
              >
                {months.map((m) => (
                  <Option value={m.value}>{m.name}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24} align="right">
            <Space>
              <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default Search;
